import React, { Component } from 'react'
import LayoutContainer from './containers/Layout'
import { connect } from 'react-redux'
import './App.css'
import { estilosOnlineSelector } from './selectors/sessionSelector'
import { sagaGetEstilosOnline } from './reducers/SessionReducer/actions'

class App extends Component {
  componentDidMount() {
    this.props.getEstilosOnline()

  }

  componentDidUpdate(prevProps) {
    if (prevProps.estilosOnline !== this.props.estilosOnline) {
      this.applyOnlineStyles()
    }
  }

  applyOnlineStyles = () => {
    const { estilosOnline } = this.props

    if (estilosOnline) {
      document.documentElement.style.setProperty(
        '--footer-backgroundcolor',
        estilosOnline.footerBackgroundcolor
      )
      document.documentElement.style.setProperty(
        '--footer-desarrollado-por-backgroundcolor',
        estilosOnline.footerDesarrolladoPorBackgroundcolor
      )
      document.documentElement.style.setProperty(
        '--top-menu-backgroundcolor',
        estilosOnline.topMenuBackgroundcolor
      )
      document.documentElement.style.setProperty(
        '--online-button-primary',
        estilosOnline.buttonPrimary
      )
      document.documentElement.style.setProperty(
        '--online-button-secondary',
        estilosOnline.buttonSecondary
      )
      document.documentElement.style.setProperty(
        '--container-turnero-background',
        estilosOnline.containerTurneroBackground
      )
      document.documentElement.style.setProperty(
        '--container-turnero-border',
        estilosOnline.containerTurneroBorder
      )
      document.documentElement.style.setProperty(
        '--container-turnero-item-horario',
        estilosOnline.containerTurneroItemHorario
      )
      document.documentElement.style.setProperty(
        '--online-links-and-buttons',
        estilosOnline.onlineLinksAndButtons
      )
      document.documentElement.style.setProperty(
        '--dropdown-delivery-pickup-background',
        estilosOnline.dropdownDeliveryPickupBackground
      )
      document.documentElement.style.setProperty(
        '--articulos-card-bubble',
        estilosOnline.articulosCardBubble
      )
      document.documentElement.style.setProperty(
        '--online-information-box-color',
        estilosOnline.onlineInformationBoxColor
      )

      document.documentElement.style.setProperty(
        '--check-out-bottoms-icons',
        estilosOnline.onlineLinksAndButtons
      )

      document.documentElement.style.setProperty(
        '--dark-check-out-bottoms-icons',
        estilosOnline.onlineLinksAndButtons
      )

      document.documentElement.style.setProperty(
        '--check-out-bottoms-icons-second',
        estilosOnline.onlineInformationBoxColor
      )
    }
  }

  render() {
    return <LayoutContainer />
  }
}

function mapStateToProps(state) {
  return {
    estilosOnline: estilosOnlineSelector(state),
  }
}

const mapDispatchToProps = {
  getEstilosOnline: sagaGetEstilosOnline,
}

export default connect(mapStateToProps, mapDispatchToProps)(App)
